export default "__VITE_ASSET__NGj_hi$m__"